export const RIDER_JOB_TYPES = {
  FULL_TIME: 'full_time',
  FREELANCE: 'freelance',
};
